import React, { CSSProperties, ReactNode } from "react";
import Loader from "@/components/Loaders/LoaderCircle/Loader";
import { cn } from "@/utils/styles";

export type ButtonSecondarySize = "sm" | "md" | "lg" | "xl";
export type ButtonSecondaryVariant = "default" | "white";

const sizeClasses: Record<ButtonSecondarySize, string> = {
  sm: "h-8 px-3 text-xs gap-1.5",
  md: "h-10 px-4 text-sm gap-2",
  lg: "h-12 px-6 text-base gap-2.5",
  xl: "h-16 px-10 text-xl gap-3",
};

const variantClasses: Record<ButtonSecondaryVariant, string> = {
  default: "bg-[#8FCA5C] text-[#242C36] border-2 border-[#8FCA5C] hover:border-white",
  white: "bg-white text-[#242C36] border-2 border-[#e0e0e0] hover:border-[#c0c0c0]",
};

const iconSizes: Record<ButtonSecondarySize, number> = {
  sm: 14,
  md: 16,
  lg: 18,
  xl: 22,
};

interface ButtonSecondaryProps {
  size?: ButtonSecondarySize;
  variant?: ButtonSecondaryVariant;
  loading?: boolean;
  disabled?: boolean;
  text: string;
  onClick?: (event?: any) => any;
  type?: "button" | "submit" | "reset";
  className?: string;
  style?: CSSProperties;
  icon?: ReactNode;
  iconPosition?: "left" | "right";
}

const ButtonSecondary = ({
  size = "md",
  variant = "default",
  loading = false,
  disabled,
  text,
  onClick,
  type = "button",
  className,
  style,
  icon,
  iconPosition = "left",
}: ButtonSecondaryProps) => {
  const isDisabled = disabled || loading;

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={isDisabled}
      style={style}
      className={cn(
        "inline-flex items-center justify-center rounded-lg font-poppins font-medium transition-all duration-150 cursor-pointer",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        variantClasses[variant],
        sizeClasses[size],
        className
      )}
    >
      {loading ? (
        <Loader isLoading={true} width={iconSizes[size]} height={iconSizes[size]} color={variant === "white" ? "#242C36" : "white"} />
      ) : (
        <>
          {icon && iconPosition === "left" && icon}
          {text}
          {icon && iconPosition === "right" && icon}
        </>
      )}
    </button>
  );
};

export default ButtonSecondary;
